import { render, staticRenderFns } from "./SliceFaq.vue?vue&type=template&id=4cf54c28&lang=pug&"
import script from "./SliceFaq.vue?vue&type=script&lang=js&"
export * from "./SliceFaq.vue?vue&type=script&lang=js&"
import style0 from "./SliceFaq.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports